import { BaseDetail } from 'App/Component/Bases'
import fields from './fields'

class PageAdd extends BaseDetail {
  title = 'Keyword Group'
  urlData = 'module-expertSystem-keywordGroup'
  fields = fields
  state = {
    isCheckingPermission: false,
    isAccessAllowed: true
  }
}

export default PageAdd